<template>
  <div class="fluid d-flex flex-column fill">
    <NavigationBar />
    <transition name="component-fade" mode="out-in">
      <router-view />
    </transition>
    <!-- <router-view v-slot="{ Component, route }">
      <transition :name="component-fade" mode="out-in">
        <component :is="Component" />
      </transition>
    </router-view> -->
  </div>
</template>

<script setup lang="ts">
  import NavigationBar from "./views/NavigationBar.vue";
</script>

<style scoped>
.fill {
  height: 100vh;
  min-height: 100%;
}

.component-fade-enter-active,
.component-fade-leave-active {
  transition: opacity 0.3s ease;
}

.component-fade-enter-from,
.component-fade-leave-to

/* .component-fade-leave-active below version 2.1.8 */
  {
  opacity: 0;
}
</style>
